module.exports = __webpack_public_path__ + "7502a04b4abcf1177f20d2440020dbb7.svg";